<template>
  <div id="app">
    <template v-if="$route.name !== 'demjansandorprogram'">
      <div id="passwordPrompt" style="display:block;">
        <input
          style="width: 300px;"
          v-model="passwordInput"
          type="password"
          @keyup.enter="verifyPassword"
          placeholder="Add meg a jelszót a továbblépéshez"
        />
        <button id="btn_contol" @click="verifyPassword">Ellenőrzés</button>
        <p id="errorMessage" style="color:red;"></p>
      </div>
      <p id="errorLoading"></p>
      <div id="front" class="page-content" style="display:none;">
        <ifka-vp-navigation></ifka-vp-navigation>
        <div class="header-spacing">
          <ifka-vp-back-button v-if="!hideBackButton()"></ifka-vp-back-button>
          <router-view />
          <ifka-vp-cookie-law></ifka-vp-cookie-law>
          <exim-popup />
        </div>
        <ifka-vp-footer></ifka-vp-footer>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BackButton from './components/BackButton.vue'
import CookieLaw from './components/CookieLaw.vue'
import EximPopup from './components/EximPopup.vue'
import Footer from './components/Footer.vue'
import Navigation from './components/Navigation.vue'

export default {
  components: {
    ifkaVpNavigation: Navigation,
    ifkaVpCookieLaw: CookieLaw,
    ifkaVpFooter: Footer,
    ifkaVpBackButton: BackButton,
    EximPopup
  },
  data() {
    return {
      passwordInput: '', // Jelszó beviteli mező
      correctPassword: 'VEY3ta5ueJh4oQ8' // A helyes jelszó
    }
  },
  computed: {
    adminNav: function() {
      if (this.$route.path) {
        return (
          this.$route.path.includes('/competitions') ||
          this.$route.path.includes('/users') ||
          this.$route.path.includes('/contents') ||
          this.$route.path.includes('/access-management')
        )
      }
      return false
    },
    ...mapGetters(['isAuthenticated', 'userHaveReadPermission'])
  },
  methods: {
    hideBackButton() {
      if (this.$route.path === '/contents') {
        return true
      }
      if (this.$route.path.includes('/fund-map/search')) {
        return true
      }
      if (this.$route.path.includes('/fund-map/fund')) {
        return true
      }
      if (this.$route.path.includes('/create-fund')) {
        return true
      }
      if (this.$route.path.includes('/fund-map/imaginary-company-details')) {
        return true
      }

      return false
    },
    checkUrl() {
      const urlTest = 'http://test.vali.hu'
      const urlDev = 'http://dev.vali.hu'
      const urlPattern = /^(http|https):\/\/[^ "]+$/
      let urlToCheck = window.location.host

      // Add http:// prefix if not present
      if (!urlPattern.test(urlToCheck)) {
        urlToCheck = 'http://' + urlToCheck
      }
      console.log('urlToCheck= ', urlToCheck)
      if (urlPattern.test(urlToCheck) && (urlToCheck === urlDev || urlToCheck === urlTest)) {
        console.log('Az URL helyes:', true)
        document.getElementById('front').style.display = 'none' // Elrejti az oldal tartalmát
        document.getElementById('passwordPrompt').style.display = 'block' // Megjeleníti a jelszó kérését
      } else {
        document.getElementById('passwordPrompt').style.display = 'none' //elrejti a jelszó kérést
        document.getElementById('front').style.display = 'block' // Elrejti az oldal tartalmát
        console.log('Az URL helytelen:', false)
      }
    },
    verifyPassword() {
      if (this.passwordInput === this.correctPassword) {
        console.log('Helyes jelszó:', true)
        //this.checkUrl() // URL ellenőrzése a jelszó helyessége után
        document.getElementById('front').style.display = 'block' // Megjeleníti az oldal tartalmát
        document.getElementById('passwordPrompt').style.display = 'none' // Elrejti a jelszó kérését
      } else {
        document.getElementById('errorMessage').innerText = 'Hibás jelszó, próbálja újra.'
        console.log('Helytelen jelszó:', false)
      }
    }
  },
  mounted() {
    this.checkUrl()
  },
  watch: {
    $route() {
      const element = document.querySelector('#nav-collapse')
      let isShown = element.classList.contains('show')
      if (isShown) {
        this.$root.$emit('bv::toggle::collapse', 'nav-collapse')
      }
    }
  }
}
</script>

<style>
@import './assets/css/Vali2.0-core.css';
@import './assets/css/Vali2.0-nav.css';
@import './assets/css/Toaster.css';

.header-spacing {
  margin-top: 130px;
}
#btn_contol {
  background-color: var(--color-green);
  border-color: var(--color-green);
  color: var(--white);
  font-weight: 700;
  border-radius: 8px;
  min-width: 0;
  height: 48px;
  padding: 0.375rem 0.75rem;
}

@media all and (max-width: 615px) {
  .header-spacing {
    margin-top: 240px;
  }
}
</style>
